import { render, staticRenderFns } from "./BlkBreadcrumbs.vue?vue&type=template&id=2446557a&"
import script from "./BlkBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./BlkBreadcrumbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports